import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Keyboard, Text } from 'grommet';
import { MapSearchResultFeature } from './map-types';
import SearchInput from './search-input';
import { BorderType } from "grommet/utils";

export type SearchProps = {
  initialValue: string | undefined;
  options?: MapSearchResultFeature[] | undefined;
  hint: string;
  inputCallback: (value: string) => void;
  setSearchInput?:
  | ((value: ((prevState: string) => string) | string) => void)
  | undefined;
  onSelectOptionCallback: (
    value: number[],
    placeName: string,
    context: any[],
  ) => void;
  button?: boolean;
  border?: BorderType;
  height?: string;
  width?: string;
};
export const SearchInputWithOptions = (props: SearchProps): JSX.Element => {
  const [value, setValue] = useState(props.initialValue ?? '');
  const [isShowOptions, setIsShowOptions] = useState<boolean>(false);
  const isMounted = useRef(false);
  const boxRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const [throttleTimeout, setThrottleTimeout] =
    useState<NodeJS.Timeout | null>();

  useEffect(() => {
    //Prevents run on first render in the case of existing initialValue
    if (isMounted.current) {
      setIsShowOptions(true);
      if (throttleTimeout) clearTimeout(throttleTimeout);
      setThrottleTimeout(
        setTimeout(() => {
          setThrottleTimeout(null);
          props.inputCallback(value.trim());
        }, 500),
      );
    } else {
      isMounted.current = true;
    }
  }, [value]);

  const onSuggestionSelect = useCallback((event: any) => {
    setValue(event.place_name);
    props.onSelectOptionCallback(event.bbox, event.place_name, event.context);
  }, []);

  const onBlur = useCallback(() => {
    setTimeout(() => {
      setIsShowOptions(false);
    }, 200);
  }, []);
  return (
    <React.Fragment>
      <Box style={{ position: 'relative' }}>
        <Keyboard
          onEnter={() => {
            if (props?.options?.length) {
              setValue(props?.options[0].place_name);
              props.onSelectOptionCallback(
                props?.options[0].center,
                props?.options[0].place_name,
                props?.options[0]['context'],
              );
              setIsShowOptions(false);
            }
          }}
        >
          <SearchInput
            setValue={setValue}
            clearSearchBarCallBack={() =>
              props.onSelectOptionCallback([], '', [])
            }
            value={value}
            boxRef={boxRef}
            hint={props.hint}
            onBlur={onBlur}
            onChange={(event) => {
              setValue(event.target.value);
              if (props.setSearchInput) {
                props.setSearchInput(event.target.value);
              }
            }}
            button={props.button}
            border={props.border}
            height={props.height}
            width={props.width}
          />
        </Keyboard>
        {isShowOptions && (
          <Box
            width={props.width ?? '100%'}
            direction='column'
            margin={`${props.height ?? '48px'} 0`}
            style={{
              position: 'absolute',
              zIndex: 1,
              background: '#fff',
            }}
          >
            {value &&
              props?.options?.map((eachItem) => {
                return (
                  <Box
                    key={eachItem['id']}
                    pad={'small'}
                    direction='column'
                    gap='small'
                    style={{borderTop: 0}}
                    border={{
                      color: '#B4BFC6',
                      size: '0.063rem',
                      position: 'bottom',
                    }}
                    onClick={() => onSuggestionSelect(eachItem)}
                  >
                    <Text color='#0D0D0D' size='16px'>
                      {eachItem.place_name}
                    </Text>
                  </Box>
                );
              })}
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
};
